import { useErrorFormatter } from "./useErrorFormatter";
import { ErrorFormatConfig } from "./types";
import { ReformReturn } from "../../../types";

/**
 * Hook wrapper for error formatting in Reform forms
 * 
 * @param reform - Reform hook return value
 * @param initialConfig - Initial error format configuration
 * @returns Form error formatter methods
 * 
 * @example
 * // Basic usage
 * const reform = useReform<UserForm>({...});
 * const errorFormatter = useReformErrorFormatter(reform);
 * 
 * // With custom configuration
 * const errorFormatter = useReformErrorFormatter(reform, {
 *   format: 'jsx',
 *   includeLabels: true
 * });
 * 
 * // Format field error
 * const error = errorFormatter.formatFieldError('email', 'Invalid email', 0);
 * 
 * // Use in JSX
 * <ErrorMessage error={error} />
 */
export const useReformErrorFormatter = <T extends Record<string, any>>(
  reform: ReformReturn<T>,
  initialConfig?: Partial<ErrorFormatConfig>
) => {
  return useErrorFormatter(reform, initialConfig);
};